import { TaskInstance } from './-private/task-instance';
import { deprecatePrivateModule } from './-private/utils';
deprecatePrivateModule('ember-concurrency/-task-instance');
export default TaskInstance;
